import { NgModule } from '@angular/core';
import { appServiceInjectionToken } from "./application/app/app-service-injection-token";
import { AppService } from "./application/app/app.service";
import { languageStateServiceInjectionToken } from "./language/languageStateServiceInjectionToken";
import { LanguageStateService } from '@zaeper/localization-lib';
import { launcherServiceInjectionToken } from "./application/launcher/launcher-service-injection-token";
import { LauncherService } from "./application/launcher/launcher.service";
import { widgetServiceInjectionToken } from "./application/widget/widget-service-injection-token";
import { WidgetService } from "./application/widget/widget.service";

@NgModule( {
  providers: [
    {
      provide: appServiceInjectionToken,
      useClass: AppService
    }, {
      provide: launcherServiceInjectionToken,
      useClass: LauncherService
    }, {
      provide: widgetServiceInjectionToken,
      useClass: WidgetService
    }, {
      provide: languageStateServiceInjectionToken,
      useClass: LanguageStateService
    }
  ]
} )
export class ServicesModule {
}
